var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMultipleFemaleMale = function SvgMultipleFemaleMale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m13.978 22.938.659-3.956h2.638L15.3 13.048c-.66-1.978-1.476-3.3-3.3-3.3s-2.637 1.319-3.3 3.3l-1.975 5.934h2.638l.659 3.956zM9.363 5.795a2.637 2.637 0 1 0 5.274 0 2.637 2.637 0 1 0-5.274 0M2.1 2.862a1.8 1.8 0 1 0 3.6 0 1.8 1.8 0 1 0-3.6 0m4.183 3.789A3.151 3.151 0 0 0 .75 8.712v1.35H2.1l.45 4.5h2.7l.22-2.2m12.83-9.5a1.8 1.8 0 1 0 3.6 0 1.8 1.8 0 1 0-3.6 0m-.583 3.789a3.151 3.151 0 0 1 5.533 2.061v1.35H21.9l-.45 4.5h-2.7l-.22-2.2"
  })));
};
export default SvgMultipleFemaleMale;